import React from 'react'
import '../Reviews/Review.css'
import Review1 from '../Images/Home/pic-1.png'
import Review2 from '../Images/Home/pic-2.png'
import { FaStar, FaStarHalfAlt  } from "react-icons/fa";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


export const Review = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 2,
        initialSlide: 0,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                infinite: true,
                dots: true
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                initialSlide: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
    };
    return (
        <div className='review'>

            <Slider {...settings}>
                <div>
                <div className="review-box">
                    <img src={Review1} alt="" />
                    <h3>John Steve</h3>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ratione possimus deserunt, distinctio error, doloremque perferendis, repellendus delectus beatae quos quas labore debitis tempora libero sint architecto voluptatibus inventore sunt? Esse.</p>
                    <div className="stars">
                        <FaStar />
                        <FaStar />
                        <FaStar />
                        <FaStar />
                        <FaStarHalfAlt  />
                    </div>
                </div>
                </div>
                <div>
                <div className="review-box">
                    <img src={Review2} alt="" />
                    <h3>Myxi</h3>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ratione possimus deserunt, distinctio error, doloremque perferendis, repellendus delectus beatae quos quas labore debitis tempora libero sint architecto voluptatibus inventore sunt? Esse.</p>
                    <div className="stars">
                        <FaStar />
                        <FaStar />
                        <FaStar />
                        <FaStar />
                        <FaStar />
                    </div>
                </div>
                </div>
                <div>
                <div className="review-box">
                    <img src={Review1} alt="" />
                    <h3>Danny</h3>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ratione possimus deserunt, distinctio error, doloremque perferendis, repellendus delectus beatae quos quas labore debitis tempora libero sint architecto voluptatibus inventore sunt? Esse.</p>
                    <div className="stars">
                        <FaStar />
                        <FaStar />
                        <FaStar />
                        <FaStar />
                        <FaStarHalfAlt  />
                    </div>
                </div>
                </div>
                <div>
                <div className="review-box">
                    <img src={Review2} alt="" />
                    <h3>Andria</h3>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ratione possimus deserunt, distinctio error, doloremque perferendis, repellendus delectus beatae quos quas labore debitis tempora libero sint architecto voluptatibus inventore sunt? Esse.</p>
                    <div className="stars">
                        <FaStar />
                        <FaStar />
                        <FaStar />
                        <FaStar />
                        <FaStar />
                    </div>
                </div>
                </div>
            </Slider>
            </div>
    )
}
